export default __webpack_public_path__ + "static/media/1025.4199c111.png";